import React, { Component } from 'react'

export default class Logo extends Component {
    render() {
        return (
            <div id="logo">
                online<strong>&nbsp;Bro</strong>
            </div>
                // <img id="logo" alt="logo" src="./style/img.png"/>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Navbar/components/Logo.js